export default [
  { title: 'Add new', icon: 'mdi-plus', action: 'addNew', _enabled: true },
  {
    title: 'Import',
    icon: 'mdi-publish',
    action: 'importSchema',
    _enabled: true
  }
  // { title: 'Recover', icon: 'mdi-delete-restore' },
];
